import { Suspense } from "react";
import { createRoot } from "react-dom/client";

import { App } from "@app";

import "./i18n/i18n";

const root = document.querySelector("#root")!;

const createdRoot = createRoot(root);

createdRoot.render(
  <Suspense fallback={null}>
    <App />
  </Suspense>,
);
